import { useState } from 'react';
import { useAuth, useEvent } from '../../context';
import { Button } from '../../components/ui';
import styles from './EventPage.module.css';

export function EventPage() {
  const { email } = useAuth();
  const { events, selectedEvent, setSelectedEvent, reloadEvents, isLoading } = useEvent();
  const [showEventList, setShowEventList] = useState(false);

  const handleSwitchEvent = (index: number) => {
    setSelectedEvent(index);
    setShowEventList(false);
  };

  if (!selectedEvent) {
    return (
      <div className={styles.container}>
        <div className={styles.titleBar}>
          <h2 className={styles.eventText}>No Event Selected</h2>
          <Button onClick={reloadEvents} disabled={isLoading}>
            {isLoading ? 'Loading...' : 'Reload Events'}
          </Button>
        </div>
        {events.length > 0 && (
          <button
            className={styles.otherEventsButton}
            onClick={() => setShowEventList(true)}
          >
            › Other Events
          </button>
        )}

        {showEventList && (
          <div className={styles.modalOverlay}>
            <div className={styles.modal}>
              <h3 className={styles.modalTitle}>Select an Event</h3>
              {events.map((ev, ix) => (
                <Button key={ev.id} onClick={() => handleSwitchEvent(ix)}>
                  {ev.title_text}
                </Button>
              ))}
              <button
                className={styles.closeButton}
                onClick={() => setShowEventList(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.titleBar}>
        <h2 className={styles.eventText}>{selectedEvent.title_text}</h2>
        <p className={styles.dateText}>{selectedEvent.date_text}</p>
      </div>

      {selectedEvent.links && selectedEvent.links.filter((l) => l.title && l.url).length > 0 ? (
        <div className={styles.buttonList}>
          {selectedEvent.links.filter((l) => l.title && l.url).map((link) => (
            <Button
              key={link.title}
              onClick={() => window.open(link.url.replaceAll('{{EMAIL}}', email || ''), '_blank')}
            >
              {link.title}
            </Button>
          ))}
        </div>
      ) : (
        <div className={styles.noInfo}>
          <p>No event information</p>
        </div>
      )}

      {events.length > 1 && (
        <button
          className={styles.otherEventsButton}
          onClick={() => setShowEventList(true)}
        >
          › Other Events
        </button>
      )}

      {showEventList && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <h3 className={styles.modalTitle}>Select an Event</h3>
            {events.map((ev, ix) => (
              <Button key={ev.id} onClick={() => handleSwitchEvent(ix)}>
                {ev.title_text}
              </Button>
            ))}
            <button
              className={styles.closeButton}
              onClick={() => setShowEventList(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default EventPage;
